import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 13\" id=\"plus\">\n    <path d=\"M7.583 0v5.416H13v2.167H7.583V13H5.417l-.001-5.417H0V5.417l5.416-.001V0h2.167z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol